export default {
    namespaced: true,
    state: {
        locale: localStorage.getItem('locale') || 'es'
    },
    getters: {
        getLocale: (state) => state.locale
    },
    mutations: {
        setLocale(state, locale) {
            state.locale = locale
        }
    }
}